<template>
  <div>
    <v-range-slider class="mt-0" v-model="dateRange" :min="0" :max="rangeScale" hide-details />
    <div class="hvh-flex space-between">
      <div>
        <HvhDatePicker :value="dateFrom" :min="dateMin" :max="dateTo" @input="dateFrom = $event">
          <template #activator="{ on }">
            <input class="date-input" v-on="on" :value="formatDate(dateFrom)" readonly />
          </template>
        </HvhDatePicker>
      </div>
      <div>
        <HvhDatePicker :value="dateTo" :min="dateFrom" :max="dateMax" @input="dateTo = $event">
          <template #activator="{ on }">
            <input class="date-input" v-on="on" :value="formatDate(dateTo)" readonly />
          </template>
        </HvhDatePicker>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
window.moment = moment;
import { formatDate } from '../../../../libraries/common';
import HvhDatePicker from '../../../common/form/datePicker/HvhDatePicker.vue';
export default {
  components: { HvhDatePicker },
  props: ['value'],
  data() {
    return {
      dateMin: moment.utc('2019-01-01').startOf('day').format(),
      dateMax: moment().utc().endOf('day').format(),
      rangeScale: 100000000,
    };
  },
  computed: {
    deltaDateMaxMin() {
      return moment.utc(this.dateMax).startOf('day') - moment.utc(this.dateMin);
    },
    milisecondsInDay() {
      return 1000 * 60 * 60 * 24;
    },
    dateFrom: {
      get() {
        return moment.utc(this.value?.from || this.dateMin).startOf('day').format();
      },
      set(value) {
        this.$emit('input', { from: moment.utc(value).startOf('day').format(), to: this.value?.to || this.dateMax });
      },
    },
    dateTo: {
      get() {
        return moment.utc(this.value?.to || this.dateMax).startOf('day').format();
      },
      set(value) {
        this.$emit('input', { from: this.value?.from || this.dateMin, to: moment.utc(value).endOf('day').format(), });
      },
    },
    dateRange: {
      get() {
        return [
          (moment.utc(this.dateFrom) - moment.utc(this.dateMin)) / this.deltaDateMaxMin * this.rangeScale,
          (moment.utc(this.dateTo) - moment.utc(this.dateMin)) / this.deltaDateMaxMin * this.rangeScale
        ];
      },
      set([from, to]) {
        var round = date => Math.round(date / this.milisecondsInDay) * this.milisecondsInDay;

        var dateFrom = moment.utc(round(moment.utc(from) / this.rangeScale * this.deltaDateMaxMin + moment.utc(this.dateMin)));
        var dateTo = moment.utc(round(moment.utc(to) / this.rangeScale * this.deltaDateMaxMin + moment.utc(this.dateMin)));
        if (this.formatDate(dateFrom) !== this.formatDate(this.dateFrom))
          this.dateFrom = dateFrom;
        if (this.formatDate(dateTo) !== this.formatDate(this.dateTo))
          this.dateTo = dateTo;
      },
    },
  },
  methods: {
    formatDate(date) {
      return formatDate(moment.utc(date).startOf('day'));
    },
  }
}
</script>

<style lang="scss" scoped>
.date-input {
  box-sizing: border-box;
  width: 88px;
  padding: 5px;
  border: 1px solid #b0b3b6;
  background-color: #ffffff;
}
</style>